
import React from 'react';
import { Box, Grid, Button, Typography, TextField, ButtonGroup } from '@mui/material';

const CommonNavigatorHeader = (props) => {

    const {total, search, setPage, page, criteria, setCriteria} = props.value;

    const handlePrevious = () => {
        var p = page-1;
        setPage(p)
        setCriteria({...criteria, page: p})
    }
    
    const handleNext = () => {
        var p = page+1;
        setPage(p)
        setCriteria({...criteria, page: p})
    }

    return (
        <Box component="span" my={1} display="flex" justifyContent="space-between" alignItems="center" sx={{margin: "10px"}}>
            <Grid container item xs={2} display="flex"> 
                <Typography>Showing: {(page)*10+1} - {total<(page+1)*10?total:(page+1)*10} of {total}</Typography>
            </Grid>
            <Grid container item xs={8} display="flex">
                <TextField 
                    label={search.label} fullWidth
                    size="small"
                    placeholder={search.placeHolder}
                    variant="outlined" 
                    //value={criteria.searchKeyword}
                    onChange={(event)=>setCriteria({...criteria, searchKeyword: event.target.value})}
                />  
            </Grid>
            <Grid container item xs={2} display="flex" justifyContent="flex-end"> 
                <ButtonGroup aria-label="outlined primary button group">
                    <Button onClick={() => handlePrevious()} size="small" disabled={page===0}>PREV</Button>
                    <Button onClick={() => handleNext()} size="small" disabled={total<(page+1)*10}>NEXT</Button>
                </ButtonGroup>
            </Grid>
        </Box>
    )
}

export default CommonNavigatorHeader;